const initialSate = {
    ring_groups: [],
    isReadingRingGroups: false,
    isCreatingRingGroups: false,
    count: 0
}

export default initialSate;
